import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRecentEventSummaryQueryVariables = Types.Exact<{
  input: Types.GetRecentEventSummaryInput;
}>;

export type GetRecentEventSummaryQuery = {
  __typename?: 'Query';
  getRecentEventSummary: {
    __typename?: 'GetRecentEventSummaryResponse';
    total: number;
    totalClosed: number;
    totalInProgress: number;
    totalUpcoming: number;
  };
};

export const GetRecentEventSummaryDocument = gql`
  query GetRecentEventSummary($input: GetRecentEventSummaryInput!) {
    getRecentEventSummary(input: $input) {
      total
      totalClosed
      totalInProgress
      totalUpcoming
    }
  }
`;
export function useGetRecentEventSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecentEventSummaryQuery,
    GetRecentEventSummaryQueryVariables
  > &
    (
      | { variables: GetRecentEventSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecentEventSummaryQuery,
    GetRecentEventSummaryQueryVariables
  >(GetRecentEventSummaryDocument, options);
}
export function useGetRecentEventSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecentEventSummaryQuery,
    GetRecentEventSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecentEventSummaryQuery,
    GetRecentEventSummaryQueryVariables
  >(GetRecentEventSummaryDocument, options);
}
export function useGetRecentEventSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecentEventSummaryQuery,
        GetRecentEventSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecentEventSummaryQuery,
    GetRecentEventSummaryQueryVariables
  >(GetRecentEventSummaryDocument, options);
}
export type GetRecentEventSummaryQueryHookResult = ReturnType<
  typeof useGetRecentEventSummaryQuery
>;
export type GetRecentEventSummaryLazyQueryHookResult = ReturnType<
  typeof useGetRecentEventSummaryLazyQuery
>;
export type GetRecentEventSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetRecentEventSummarySuspenseQuery
>;
export type GetRecentEventSummaryQueryResult = Apollo.QueryResult<
  GetRecentEventSummaryQuery,
  GetRecentEventSummaryQueryVariables
>;
export function refetchGetRecentEventSummaryQuery(
  variables: GetRecentEventSummaryQueryVariables,
) {
  return { query: GetRecentEventSummaryDocument, variables: variables };
}
